export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40b5051d327e86d36b1282d4eda7c2a035773eaa62&name=revalidateCommunity!'